export const NewInvestmentConstants = {
    sectionHeading : 35,
    subHeading : 35
}